// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
//
// How many people can sit down at one machine (08 §4.2, S3-09).
//
// One line, in its own file, because **two things depend on it and they are in different worlds**:
// `MachineStage` draws the segmented control a player picks a seat count with, and the prerenderer
// tells a search engine that a machine page seats more than one person. The second is a claim
// about the first. Left inside the component, the claim could only be checked by importing React
// and Three.js into a Node test, which is the sort of cost that makes a guard not get written.
//
// The ceiling is the same four `core/ts/machine/validate.ts` bounds `meta.playersMax` to, and a
// machine's own definition is what decides how many of these are offered for it — this is the
// widest the product ever goes, not the number any particular machine seats.
export const SEATS = [1, 2, 3, 4] as const
